import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom-v6'
import { Alert, AlertDescription, Skeleton } from '@clouway/ui'

import { useDateFormatter } from '@/hooks/useDateFormatter'
import { StatusMap } from '../components/StatusMap'
import { TelemetryPanel } from '../components/TelemetryPanel'
import { useTrackingObjectStatus } from '../hooks'
import type { RoutePoint } from '../types'

export function TrackingObjectStatus() {
  const { t } = useTranslation('feature')
  const { formatDateTime } = useDateFormatter()
  const { id = '', tid = '' } = useParams<{ id: string; tid: string }>()
  const { data: info, isSuccess, isLoading } = useTrackingObjectStatus(id, tid)
  const [selected, setSelected] = useState<RoutePoint | null>(null)

  const route = info?.recentRoute ?? []

  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col gap-4">
      <div className="flex items-center justify-between gap-2">
        <h1 className="text-lg font-semibold">{t('trackingObjects.status.statusAt')}</h1>
        {info && <span className="text-muted-foreground text-sm">{formatDateTime(info.statusTime)}</span>}
      </div>

      {isLoading && <Skeleton className="h-[60vh] w-full" />}

      {isSuccess && route.length === 0 && (
        <Alert>
          <AlertDescription>{t('trackingObjects.status.noRecentRoute')}</AlertDescription>
        </Alert>
      )}

      {isSuccess && route.length > 0 && <StatusMap route={route} onSelect={setSelected} />}

      {selected && <TelemetryPanel point={selected} onClose={() => setSelected(null)} />}
    </div>
  )
}
